import { useRef, useEffect, useCallback } from 'react';

const ACTIVITY_EVENTS = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];

/**
 * Track user activity and provide an `isIdle()` check.
 * Returns a stable callback that returns true when the user has been idle
 * for longer than `idleMs` or the document is hidden.
 * Pass 0 or falsy to disable idle detection (isIdle always returns false).
 */
export default function useIdleAware(idleMs) {
  const lastActivity = useRef(Date.now());

  useEffect(() => {
    if (!idleMs) return;
    const mark = () => { lastActivity.current = Date.now(); };
    ACTIVITY_EVENTS.forEach(e => window.addEventListener(e, mark, { passive: true }));
    return () => ACTIVITY_EVENTS.forEach(e => window.removeEventListener(e, mark));
  }, [idleMs]);

  return useCallback(() => {
    if (document.hidden) return true;
    if (idleMs > 0 && Date.now() - lastActivity.current > idleMs) return true;
    return false;
  }, [idleMs]);
}
